'use client'

import { styled } from 'styled-components'

import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'

export const Content = styled.div`
  width: 100%;
  max-width: var(--maxPageWidth);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  border: 0.125rem solid ${Colors.Semantic.Neutral.medium_grey};
  border-radius: 1rem;
  background: ${Colors.Semantic.Neutral.white};
  padding: 2rem;

  @media ${Breakpoints.max.medium} {
    width: 100%;
    min-width: 18.4rem;
    padding: 1rem;
    gap: 0.625rem;
    border-radius: 1rem;
    background: ${Colors.Semantic.Neutral.white};
  }
`

export const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`

export const TitleWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: ${Colors.Semantic.BStock.default.lightBackground};
  font-size: 1.25rem;

  @media ${Breakpoints.max.medium} {
    font-size: 1.125rem;
  }
`

export const Title = styled.h2`
  ${Typography.Subtitle1};
  color: ${Colors.Semantic.Neutral.light_black};
`

export const SearchList = styled.div`
  display: flex;
  flex-direction: column;
`

export const SearchCriteriaText = styled.p`
  ${Typography.Body3};
  color: ${Colors.Semantic.Neutral.light_black};
  max-width: 53.3125rem;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${Breakpoints.max.medium} {
    ${Typography.Body3_Semibold};
  }
`
